import httpClient from "./httpClient";

export default {
  async login(user, config = {}) {
    const response = await httpClient.post("/auth/login", { ...user }, config);
    return response.data;
  },

  async forgotPassword(email, config = {}) {
    const response = await httpClient.post(
      "/auth/forgot_password",
      { email },
      config
    );
    return response.data;
  },

  async resetPassword(user, config = {}) {
    const response = await httpClient.post(
      "/auth/reset_password",
      { ...user },
      config
    );
    return response.data;
  }
};
